import type { CostRange } from '../services/reportsApi';

export function formatDate(
  dateString: string | undefined,
  options: { includeTime?: boolean; monthFormat?: 'short' | 'long' } = {}
): string {
  if (!dateString) return 'Unknown';

  const { includeTime = true, monthFormat = 'short' } = options;

  const formatOptions: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: monthFormat,
    day: 'numeric',
    ...(includeTime && { hour: '2-digit', minute: '2-digit' })
  };

  return new Date(dateString).toLocaleDateString('en-US', formatOptions);
}

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(amount);
}

/** "range $1,275 - $1,725", or null when the range has no band (low === high). */
export function formatRangeBand(range: CostRange): string | null {
  if (range.low === range.high) return null;
  return `range ${formatCurrency(range.low)} - ${formatCurrency(range.high)}`;
}

/**
 * The one repair-cost format: "$1,500 (range $1,275 - $1,725)"; a range with no
 * band (an override) prints "$1,500". Mirrors backend/services/email/cost_format.py.
 */
export function formatCostRange(range: CostRange): string {
  const band = formatRangeBand(range);
  return band ? `${formatCurrency(range.expected)} (${band})` : formatCurrency(range.expected);
}

/** Build a tel: href from a phone string. Returns '' when there are no dialable digits. */
export function telHref(phone: string | undefined): string {
  const digits = (phone ?? '').replace(/\D/g, '');
  return digits ? `tel:${digits}` : '';
}
